<h2 mat-dialog-title>INFORMACIÓN PEDIDOS</h2>
<mat-dialog-content class="mat-typography">
  <div class="row">
    <div class="col s12 m12 l12" *ngIf="loadingPedidos">
      <mat-spinner [diameter]="100" style="top: 15px;"></mat-spinner>
    </div>
    <div class="col s12 m12 l12" *ngIf="!loadingPedidos">
      <mat-nav-list>
        <div mat-subheader>PEDIDOS</div>
        <mat-list-item *ngFor="let item of pedidos">
          <h3 class="titulo-item" mat-line>
            Razón Social: {{ item.razonSocial }} Dirección: {{ item.direccion }}
          </h3>
          <p mat-line>
            <span class="subtitulo-item"
              >Producto: {{ item.idExProducto }} -- {{ item.nombreProducto }}
            </span>

            <span style="font-weight: bold;"> Cantidad Pedida: </span>
            {{ item.cantidad }}
            &nbsp;&nbsp;&nbsp;
            <mat-form-field class="example-full-width">
              <mat-label>CANTIDAD PICKING</mat-label>
              <input
                matInput
                placeholder="CANTIDAD PICKING"
                [value]="item.cantidadDespacho"
                (keydown.enter)="onKey(item, $event)"
                (blur)="onKey(item, $event)"
              />
            </mat-form-field>
          </p>
          <mat-divider></mat-divider>
        </mat-list-item>
      </mat-nav-list>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="start">
  <div>
    <div style="float: left;">
      <p style="color: green; font-weight: bold;">CANTIDAD PEDIDO:</p>
      <p style="color: red; font-weight: bold;">CANTIDAD PICKING:</p>
    </div>
    <div style="float: left; margin-left: 20px;">
      <p style="color: gray; font-weight: bold;">
        {{ cantidadTotalPedido }}
      </p>
      <p style="color: gray; font-weight: bold;">
        {{ cantidadPicking }}
      </p>
    </div>
  </div>
  <button
    mat-raised-button
    color="primary"
    (click)="cerrar('aceptar')"
    style="float: left; margin-left: 80%;"
    [disabled]="deshabilitado"
  >
    Aceptar
  </button>
  <button
    mat-button
    style="float: left; margin-left: 2%;"
    (click)="cerrar('cancelar')"
  >
    Cancelar
  </button>
</mat-dialog-actions>
